import { WalletConnectLoginButton, LedgerLoginButton, ExtensionLoginButton } from '@multiversx/sdk-dapp/UI';
import style from './MultiversXConnectView.module.scss';
import { useGetAccountInfo } from '@multiversx/sdk-dapp/hooks';
import { useEffect } from 'react';

export const MultiversXConnectView = ({ setAddress }) => {
    const { account } = useGetAccountInfo();

    useEffect(() => {
        if (account && account.address) {
            setAddress(account.address);
        }
    }, [account, setAddress]);

    return (
        <div className={style.multiversXConnect}>
            <h1>Connect Your Wallet</h1>
            <span>Choose one of the option below</span>
            <div className="options">
                <WalletConnectLoginButton buttonClassName="option">
                    <span>Mobile</span>
                    <img src="assets/icons/x-portal-app.png" alt="xPortal App icon" />
                    <strong>xPortal App</strong>
                </WalletConnectLoginButton>
                <LedgerLoginButton buttonClassName="option">
                    <span>Hardware</span>
                    <img src="assets/icons/ledger.png" alt="Ledger icon" />
                    <strong>Ledger</strong>
                </LedgerLoginButton>
                <ExtensionLoginButton buttonClassName="option">
                    <span>Extension</span>
                    <img src="assets/icons/defi-wallet.png" alt="Defi Wallet icon" />
                    <strong>Defi Wallet</strong>
                </ExtensionLoginButton>
            </div>
        </div>
    );
};
